class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      $.getJSON('/cart.js').then(cart => {
        var htm = '';
        cart.items.forEach(function(item) {
          htm += '<div class="row-cart">';
          if (item && item.featured_image && item.featured_image.url) {
          htm += '<img class="cart-notification-product__image" src="'+item.featured_image.url+'" alt="" width="119" height="123" loading="lazy">';
          } else {
            htm += '<img class="cart-notification-product__image" src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" alt="" width="119" height="123" loading="lazy">';
          }
          htm += '<a href="javascript:void(0)" class="removeitem" data-variant-id="'+item.id+'">X Remove</a>';
          htm += '<div class="cart_item_content">';
          htm += '<a href="'+item.url+'">';
          htm += '<h3 class="cart-notification-product__name h4">'+item.product_title+'</h3>';
          htm += '</a>';
          htm += '<dl><div class="product-option bhc-'+item.options_with_values[0].value+'">';
          htm += '<dt>'+item.options_with_values[0].name+': </dt>';
          htm += '<dd>'+item.options_with_values[0].value+'</dd>';
          htm += '</div>';
          htm += '<div class="product-option">';
          htm += '<dt>Qty: </dt>';
          htm += '<dd>'+item.quantity+'</dd>';
          htm += '</div>';
          htm += '</dl>';
          htm += '</div>';
          htm += '</div>';
        });
        $('#cart-notification-product').html(htm);
        var a = cart.total_price/100;
        a = a.toFixed(2);
        $('.mini-cart-total-price span').text('$'+a+' AUD');
        $('.cart-count-bubble span').html('('+cart.item_count+')');
        $('.point-to-icon').addClass('animate active');
        $('body').addClass('drawer--open');
        $('.overlay_body').show();
        
        
        if (cart.items.length == 0) {
          $('div#cart-notification .cart-notification__links').hide();
          $('.cartempty').show();
        } else {
          $('.cartempty').hide();
          $('div#cart-notification .cart-notification__links').show();
        }
            jQuery.get('/cart?view=cart_free_shipping', function(pro) {
              $('.productshippingbar').html(pro);
            }).fail(function(jqXHR, textStatus, errorThrown) {
              console.log('getJSON request failed! ' + textStatus);
            }).done(function(){
              // $this.removeClass('recommendations');
            });
      })
      .fail(function(err){
        console.log(err);
      });

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
